export default {
    typography: {
        htmlFontSize: 12,
        fontFamily: 'Poppins',
        color: '#344A5E'
    },
    overrides: {
        MuiPaper: {
            elevation4: {
                boxShadow: 'none',
                border: '1px solid #D6DBDF'
            }
        },
        MUIDataTableBodyCell: {
            root: {
                fontWeight: 600
                // backgroundColor: "blue"
            }
        },
        MUIDataTableHeadCell: {
            root: {
                fontWeight: 600
                // backgroundColor: "blue"
            }
        },
        MuiTableRow: {
            root: {
                cursor: 'pointer',
                transition: '.3s',
                '&:nth-child(odd)': {
                    backgroundColor: '#FAFAFA'
                },
                "&$selected": {backgroundColor: "#0f99601c !important",}
            },
            hover: {
                "&:hover": {
                    backgroundColor: "rgba(38, 170, 225, 0.2) !important"
                }
            },
            // selected: {
            //     backgroundColor: "rgba(19, 124, 189, 0.1) !important"
            // }
        },
        MuiIconButton: {
            label: {
                // fontSize: 30
                // color: "#344A5E"
            }
        },
        MUIDataTableSelectCell: {
            fixedLeft: {
                zIndex: 1
            },
            root: {},
            checkboxRoot: {
                color: "#D6DBDF !important",
            },
            checked: {
                color: "#344A5E !important"
            },
        },
        MUIDataTableToolbarSelect: {
            root: {
                paddingTop: 5,
                paddingBottom: 5,
                paddingRight: 20,
                paddingLeft: 20,
                backgroundColor: '#fff',
                boxShadow: 'none',
                zIndex: 1
            }
        },
        MuiTooltip: {
            tooltip: {
                fontSize: 12,
            }
        },
        MuiInput: {
            underline: {
                "&:after": {
                    borderBottom: '2px solid #18A9E3'
                }
            }
        },
        MUIDataTableToolbar: {
            icon: {
                "&:hover": {
                    color: '#18A9E3'
                }
            },
            iconActive: {
                color: '#18A9E3'
            }
        },
        MuiCheckbox: {
            colorPrimary: {
                "&.Mui-checked": {
                    color: '#344A5E'
                }
            }
        },
        MuiChip: {
            root: {
                borderRadius: 4
            }
        },
        MuiButton: {
            textPrimary: {
                color: '#18A9E3'
            }
        }
    }
}